import { Box, useMediaQuery, Avatar, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PolicyListingResponsive from "../PolicyListingResponsive/PolicyListingResponsive";
import filterIcon from "../../assets/svgs/filter-icon.svg";
import {
  ADD_TASK,
  CUSTOMER,
  FILTER,
  POLICIES,
  TAB1,
  TAB2,
  VIEW_LESS,
  VIEW_MORE,
  PENDING_RENEWAL,
  ACTIVE,
  CANCELLED_CAPS,
  FUTURE_CAPS,
  NON_RENEW_REQUESTED_CAPS,
  CANCEL_NOTICE_CAPS,
  FUTURE_Expired_CAPS,
} from "../../constants";
import TabSwitch from "../../common/TabSwitch/TabSwitch";
import HeadingText from "../../common/HeadingText/HeadingText";
import docIcon from "../../assets/svgs/document-icon.svg";
import docIconBlack from "../../assets/svgs/document-icon-black.svg";
import personIconWhite from "../../assets/svgs/person-icon-white.svg";
import personIcon from "../../assets/svgs/person-icon.svg";
import { PolicyListingStyles } from "./PolicyListingStyles";
import HeadingSubHeading from "../../common/HeadingSubHeading/HeadingSubHeading";
import ImageAndText from "../ImageAndText/ImageAndText";
import { filterPopUpCommonOptions } from "../../constants/FilterPopUpCommonOptions";
import { policyListingHeaderData } from "../../constants/PolicyListingHeaderData";
import dropDownArrowIcon from "../../assets/svgs/drop-down-arrow.svg";
import upSideDownArrowIcon from "../../assets/svgs/upside-down-icon.svg";
import CustomButton from "../../common/CustomButton/CustomButton";
import Drawers from "../Drawers/Drawers";
import FilterPopUp from "../FilterPopUp/FilterPopUp";
import PolicyListingList from "../PolicyListingList/PolicyListingList";
import NewTask from "../NewTask/NewTask";
import { GetAgentPolicies } from "./PolicyListingAction";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  IAgentPoliciesListing,
  IAgentPoliciesRequestBody,
} from "../../models/agent/policiesListing";
import { currencyFormat, getCookie } from "../../utils/Utility";
import { RootState } from "../../store/store";
import Tables from "../Tables/Tables";
import styled from "@emotion/styled";
import BasicTabs from "../../common/BasicTabs/BasicTabs";
import stringAvatar from "../../utils/StringAvatar";
import activeIcon from "../../assets/svgs/active-icon.svg";
import pendingIcon from "../../assets/svgs/pending-icon.svg";
import { useNavigate } from "react-router-dom";
import AgentCustomTable from "../AgentCustomTable/AgentCustomTable";
import { GetPolicyMetrics } from "./PolicyMetrics/PolicyMetricsAction";
import { Dispatch } from "@reduxjs/toolkit";
import cancelIcon from "../../assets/svgs/cancelled-icon.svg";

const TabList = styled("div")({
  "& .MuiTabs-flexContainer": {
    "& .MuiTypography-root": {
      fontFamily: "var(--font-playfair-display)",
      fontSize: "var(--font-size-20)",
    },
  },
});

const StyledCustomerDetailsAvatar = styled(Box)({
  "& .MuiAvatar-root": {
    width: "32px",
    height: "32px",
    border: "1px solid var(--primary-grey)",
  },
});

interface Action<T> {
  type: string;
  payload: T;
}

const PolicyListing: React.FC = () => {
  const { agentDetails } = useAppSelector(
    (state: RootState) => state.agentAuth
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const providerId = getCookie("id");
  const carrier = getCookie("carrier");
  const system = getCookie("system");
  const { policyList, currentContinuationId } = useAppSelector(
    (state: RootState) => state.agentPolicies
  );

  const handleNavigate = (
    policyId: string,
    lobCode: string | null | undefined,
    customerId: string | null | undefined
  ) => {
    if (!policyId || !lobCode) {
      return;
    }
    navigate(
      `/agent/policyDetails/${policyId}/${carrier}/${system}/${lobCode}/${customerId}`
    );
  };

  const {
    activePolicies,
    cancelNoticePolicies,
    cancelledPolicies,
    nonRenewRequestedPolicies,
    renewalInprogressPolicies,
    totalPolicies,
    nonPayCancelledPolicies,
    futureExpiredPolicies,
  } = useAppSelector((state) => state.agentPolicyMetrics);

  const [statusCode, setStatusCode] = useState<string | null>("");
  const [showFilters, setShowFilters] = useState(false);

  const policyMetrics = [
    { key: "Active", data: activePolicies },
    {
      key: "Cancel Notice",
      data: cancelNoticePolicies,
    },
    {
      key: "Cancelled",
      data: cancelledPolicies,
    },
    {
      key: "Renewal In Progress",
      data: renewalInprogressPolicies,
    },
    {
      key: "Non-Renew Requested",
      data: nonRenewRequestedPolicies,
    },
    {
      key: "Non-Pay Cancelled",
      data: nonPayCancelledPolicies,
    },
    {
      key: "Future Expired",
      data: futureExpiredPolicies,
    },
    { key: "Total", data: totalPolicies },
  ];

  const getHeaderData = (policyMetrics: any) => {
    return policyMetrics.map(({ key, data }: { key: string; data: any }) => ({
      heading: data ? data?.count : "-",
      subHeading: key,
    }));
  };

  const policyListHeader = [
    {
      label: "Policy Details",
      Cell: (row: any) => {
        if (!row) {
          return "";
        }
        let policyText = "";
        if (row.lobCode == "PA") {
          policyText = "Auto";
        }
        if (row.lobCode == "HO") {
          policyText = "Home";
        }
        if (row.lobCode == "PU") {
          policyText = "Umbrella";
        }
        if (row.lobCode == "BOP") {
          policyText = "Business";
        }
        if (row.lobCode == "FO") {
          policyText = "Farm";
        }
        return (
          <Box sx={PolicyListingStyles.policyDetails}>
            <Typography
              onClick={() =>
                handleNavigate(row.policyId, row.lobCode, row.customerId)
              }
              sx={PolicyListingStyles.policyNumber}
            >
              {row.carrierPolicyNo}
            </Typography>
            <Typography sx={PolicyListingStyles.policyTypeNumber}>
              {policyText}
            </Typography>
          </Box>
        );
      },
    },
    {
      label: "Insured Details",
      Cell: (row: any) => {
        return (
          <Box sx={PolicyListingStyles.customerDetailsContainer}>
            <StyledCustomerDetailsAvatar>
              <Avatar {...stringAvatar(row.insuredName?.toUpperCase())} />
            </StyledCustomerDetailsAvatar>
            <Box>
              <Typography sx={PolicyListingStyles.customerName}>
                {row.lobCode === "BOP" ? row?.businessName : row?.insuredName}
              </Typography>
              <Typography sx={PolicyListingStyles.customerNumber}>
                {row?.insuredPhone}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      label: "Status",
      Cell: (row: any) => {
        let policyStatus = "";
        let policyStatusImg = null;

        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "pending"
        ) {
          policyStatus = PENDING_RENEWAL;
          policyStatusImg = pendingIcon;
        }
        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "active"
        ) {
          policyStatus = ACTIVE;
          policyStatusImg = activeIcon;
        }
        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "cancelled"
        ) {
          policyStatus = CANCELLED_CAPS;
          policyStatusImg = cancelIcon;
        }
        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "future"
        ) {
          policyStatus = FUTURE_CAPS;
          policyStatusImg = activeIcon;
        }
        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "non-renew requested"
        ) {
          policyStatus = NON_RENEW_REQUESTED_CAPS;
          policyStatusImg = activeIcon;
        }
        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "cancel notice"
        ) {
          policyStatus = CANCEL_NOTICE_CAPS;
          policyStatusImg = activeIcon;
        }
        if (
          row &&
          row.carrierPolicyStatus &&
          row.carrierPolicyStatus.toLowerCase() === "future expired"
        ) {
          policyStatus = FUTURE_Expired_CAPS;
          policyStatusImg = cancelIcon;
        }
        return (
          <ImageAndText
            imageClassName={PolicyListingStyles.policyStatusImg}
            image={policyStatusImg}
            text={policyStatus}
          />
        );
      },
    },
    {
      label: "Premium",
      Cell: (row: any) => {
        return row ? currencyFormat("us", row.finalPremiumAmount) : "-";
      },
    },
    {
      label: "Term",
      accessorKey: "tenure",
    },
    {
      label: "Carrier",
      accessorKey: "carrierGroupCd",
    },
  ];

  if (statusCode === "Cancelled") {
    policyListHeader.splice(3, 0, {
      label: "Reason",
      Cell: (row: any) => {
        return row.cancelRequestedByCd || "-";
      },
    });
  }

  const [policiesPerPage, setPoliciesPerPage] = useState("500");
  const [continuationId, setContinuationId] = useState(
    currentContinuationId || ""
  );
  const [prevId, setPrevId] = useState(null);
  const [totalPoliciesNUmber, setTotalPoliciesNumber] = useState<number>(0);

  const getStatusCode = (key: string) => {
    if (key === null || key === "" || key === undefined || key === "Active")
      return "Active";
    const metric = policyMetrics.find(
      (metric) => metric.key === key && metric.data?.statusCd
    );
    return metric ? metric?.data?.statusCd ?? null : null;
  };
  useEffect(() => {
    if (agentDetails) {
      const requestParams: IAgentPoliciesRequestBody = {
        providerId,
        carrier,
        system,
        //For Non-pay cancelled policies, sending limit as no.of total cancelled policies
        // policiesLimit:
        //   statusCode === "Non-Pay Cancelled"
        //     ? `${cancelledPolicies?.count}`
        //     : policiesPerPage,
        policiesLimit: "500",
        continuationId: "",
        prevContinuationId: "",
        statusCd: getStatusCode(statusCode || ""),
        producerTypeCd: agentDetails?.producerTypeCd || "",
        providerCd: agentDetails?.providerCd || "",
      };
      dispatch(GetAgentPolicies(requestParams));
    }
  }, [
    dispatch,
    policiesPerPage,
    continuationId,
    statusCode,
    prevId,
    agentDetails,
  ]);

  const isSmallScreen = useMediaQuery("(max-width:1023px)");
  const [activeTab, setActiveTab] = useState(TAB1);
  const [isSlide, setIsSlide] = useState(false);
  const [isViewMore, setIsViewMore] = useState(true);
  const [notesOpen, setNotesOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState("1");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [headerData, setHeaderData] = useState(
    isSmallScreen
      ? policyListingHeaderData.slice(0, 4)
      : policyListingHeaderData
  );

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    setIsSlide(tab === TAB2);
  };

  const handleSlicing = () => {
    if (isViewMore) {
      setHeaderData(policyListingHeaderData);
      setIsViewMore(false);
    } else {
      setHeaderData(policyListingHeaderData.slice(0, 4));
      setIsViewMore(true);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    handleClose();
  };
  const handleNotesClick = () => {
    setNotesOpen(!notesOpen);
  };

  const getPoliciesThatNeedAttention = (policies: IAgentPoliciesListing[]) => {
    return policies.filter((policy) => policy.carrierPolicyStatus !== "Active");
  };

  useEffect(() => {
    if (agentDetails) {
      dispatch(
        GetPolicyMetrics({
          providerId: providerId,
          carrier: carrier,
          system: system,
          policiesLimit: "500",
          producerTypeCd: agentDetails?.producerTypeCd || "",
          providerCd: agentDetails?.providerCd || "",
        })
      );
    }
  }, [dispatch, agentDetails]);

  useEffect(() => {
    const metric = policyMetrics.find((metric) => metric.key === statusCode);
    if (metric) {
      setTotalPoliciesNumber(metric.data?.count || 0);
    } else {
      setTotalPoliciesNumber(activePolicies?.count || 0);
    }
  }, [statusCode, activePolicies]);

  const policyListingTabsData = [
    {
      label: "All Policies",
      content: (
        <AgentCustomTable
          headerData={policyListHeader}
          type="policyListing"
          primary={false}
          data={policyList}
          additionaltableContainer={PolicyListingStyles.tableContainer}
          handleRowClick={handleNavigate}
          requestFrom="policyListing"
          setPoliciesPerPage={setPoliciesPerPage as Dispatch<Action<string>>}
          policiesPerPage={policiesPerPage}
          totalPolicies={totalPoliciesNUmber}
          setContinuationId={setContinuationId as Dispatch<Action<any>>}
          setPrevId={setPrevId as Dispatch<Action<any>>}
          showFilters={showFilters}
          statusCode={statusCode || "Total"}
        />
      ),
    },
    {
      label: "Policies That Need Attention",
      content: (
        <AgentCustomTable
          type="policyListing"
          primary={false}
          data={getPoliciesThatNeedAttention(policyList)}
          headerData={policyListHeader}
          additionaltableContainer={PolicyListingStyles.tableContainer}
          setPoliciesPerPage={setPoliciesPerPage as Dispatch<Action<string>>}
          policiesPerPage={policiesPerPage}
          totalPolicies={totalPolicies?.count || 0}
        />
      ),
    },
  ];

  useEffect(() => {
    if (statusCode === "Cancelled") {
      setShowFilters(true);
    } else {
      setShowFilters(false);
    }
  }, [statusCode]);

  return (
    <>
      <Box sx={PolicyListingStyles.container}>
        <Box sx={PolicyListingStyles.innerContainer}>
          <Box sx={PolicyListingStyles.tabsContainer}>
            <HeadingText heading={POLICIES} />
            <Box sx={PolicyListingStyles.rightContainer}>
              {isSmallScreen && statusCode === "Cancelled" && (
                <ImageAndText
                  additionalClassName={PolicyListingStyles.filterIcon}
                  onhandleClick={handleClick}
                  image={filterIcon}
                  text={FILTER}
                />
              )}

              {/* <TabSwitch
                tab1Title={POLICIES}
                tab2Title={CUSTOMER}
                tab1ActiveImage={docIconBlack}
                tab2ActiveImage={personIcon}
                tab2InActiveImage={personIconWhite}
                tab1InActiveImage={docIcon}
                handleTabClick={handleTabClick}
                activeTab={activeTab}
                isSlide={isSlide}
              /> */}
            </Box>
          </Box>
          <Box sx={PolicyListingStyles.headerContainer}>
            {getHeaderData(policyMetrics).map((item: any, index: number) => (
              <HeadingSubHeading
                key={index}
                heading={item.heading}
                headingAdditionalClassName={
                  PolicyListingStyles.headingContainerText
                }
                containerAdditionalClassName={
                  PolicyListingStyles.headingSubheadingContainer
                }
                subHeadingAdditionalClassName={
                  PolicyListingStyles.subHeadingContainerText
                }
                subheading={item.subHeading}
                setStatusCode={setStatusCode as Dispatch<Action<string>>}
                setContinuationId={setContinuationId as Dispatch<Action<any>>}
                setPrevId={setPrevId as Dispatch<Action<any>>}
                statusCode={statusCode || ""}
              />
            ))}
            {/* {isSmallScreen && (
              <Box
                sx={{
                  ...PolicyListingStyles.footerImageAndText,
                  justifyContent: isViewMore ? "flex-end" : "center",
                }}
              >
                {isViewMore ? (
                  <ImageAndText
                    additionalClassName={PolicyListingStyles.viewMoreContainer}
                    onClick={handleSlicing}
                    image={dropDownArrowIcon}
                    text={VIEW_MORE}
                  />
                ) : (
                  <ImageAndText
                    additionalClassName={PolicyListingStyles.viewLessContainer}
                    onClick={handleSlicing}
                    image={upSideDownArrowIcon}
                    text={VIEW_LESS}
                  />
                )}
              </Box>
            )} */}
          </Box>
        </Box>
        <Box>
          {isSmallScreen ? (
            <PolicyListingResponsive
              activeTab={activeTab}
              policyListingData={policyList}
              policiesThatNeedAttention={getPoliciesThatNeedAttention(
                policyList
              )}
              setContinuationId={setContinuationId as Dispatch<Action<any>>}
              setPrevId={setPrevId as Dispatch<Action<any>>}
              showFilters={showFilters}
              // customerPoliciesData={customerPoliciesData}
              // customerPoliciesThatNeedAttention={
              //   customerPoliciesThatNeedAttention
              // }
            />
          ) : (
            <TabList>
              <BasicTabs tabs={policyListingTabsData} />
            </TabList>
          )}
        </Box>
      </Box>

      <Drawers
        open={notesOpen}
        toggleDrawer={handleNotesClick}
        heading={ADD_TASK}
        additionalClass={PolicyListingStyles.drawer}
      >
        <NewTask onCancelClick={handleNotesClick} />
      </Drawers>

      <FilterPopUp
        options={filterPopUpCommonOptions}
        selectedKey={selectedKey}
        onSelect={handleSelect}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default PolicyListing;
